module.exports = __webpack_public_path__ + "static/media/delete.b816f5c5.svg";